export default __webpack_public_path__ + "static/media/i243sp.2b78b20b.webp";